module.exports = __webpack_public_path__ + "media/packs/images/details/documents-2a10c96d3a198729a1240993a8b23c02.svg";